export default            
    {
        path:'/user',
        name:'用户页',
        component:()=>import('../views/user/index'),
        children:[
            {
                path:'/login',
                name:'登录',
                component:()=>import('../views/user/login'),
            },
            {
                path:'/register',
                name:'个人注册',
                component:()=>import('../views/user/register'),
            },
            {
                path:'/forgetPassword',
                name:'忘记密码',
                component:()=>import('../views/user/forgetPassword'),
            },
            {
                path:'/campusCard',
                name:'绑定校园卡',
                component:()=>import('../views/user/campusCard'),
            },
            {
                path:'/bindPhone',
                name:'绑定手机号',
                component:()=>import('../views/user/bindPhone'),
            },
            {
                path:'/perfectInformation',
                name:'完善个人信息',
                component:()=>import('../views/user/PerfectInformation')
            },
            
        ]
    }